module.exports = __webpack_public_path__ + "img/icon-search-cancel.fbd38a5e.svg";